import React from "react";
import { Box, TextField, Button, Typography, CircularProgress } from "@mui/material";
import useProgressPhotoGroupReview from "../../hooks/useProgressPhotoGroupReviews";

/**
 * Coach notes for one progress photo group — same component everywhere (client summary,
 * reports, media).
 */
const ProgressPhotoGroupReviewNotes = ({
  clientId,
  groupId,
  defaultExpanded = true,
}) => {
  const { coachNotes, loading, saving, saveNotes } = useProgressPhotoGroupReview(
    clientId,
    groupId,
  );
  const [draft, setDraft] = React.useState("");

  React.useEffect(() => {
    setDraft(coachNotes ?? "");
  }, [coachNotes]);

  const handleSave = React.useCallback(async () => {
    await saveNotes(draft);
  }, [draft, saveNotes]);

  if (!clientId || !groupId) return null;

  return (
    <Box sx={{ mt: 1.5, pt: 1.5, borderTop: 1, borderColor: "divider" }}>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
        Coach notes (saved with this photo group)
      </Typography>
      {loading ? (
        <CircularProgress size={20} />
      ) : (
        <>
          <TextField
            multiline
            minRows={defaultExpanded ? 2 : 1}
            maxRows={8}
            fullWidth
            size="small"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="Notes for this submission — visible wherever this group is shown."
          />
          <Button
            size="small"
            variant="outlined"
            onClick={handleSave}
            disabled={saving || draft === (coachNotes ?? "")}
            sx={{ mt: 1, textTransform: "none", fontWeight: 600 }}
          >
            {saving ? "Saving…" : "Save notes"}
          </Button>
        </>
      )}
    </Box>
  );
};

export default ProgressPhotoGroupReviewNotes;
